import { Zap } from "lucide-react";

const ITEMS = [
  "LIFTS",
  "DIESEL PERFORMANCE",
  "WHEEL LIGHTS",
  "UNDERGLOW",
  "AUDIO & SUBS",
  "PAINT MATCH & BODY WORK",
  "WHEELS & TIRES",
  "ACCESSORIES",
];

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-zinc-800/80 bg-[#0A0A0D] py-5" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max items-center whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display text-2xl sm:text-4xl font-black uppercase italic tracking-tight px-6 ${
              i % 2 === 0 ? "text-white" : "text-outline-volt"
            }`}
          >
            {t}
          </span>
          <Zap size={22} className="text-bolt shrink-0" fill="currentColor" />
        </span>
      ))}
    </div>
  </div>
);
